// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import { v4 as uuidv4 } from "uuid";

import { Api } from "../../../api";

interface RowData {
  cols: ColData[];
}

interface ColData {
  image: string;
  text: string;
  value: ColValue | string;
}

interface ColValue {
  service?: string;
  filter?: {
    FILTER?: string;
  };
}

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class TableModule extends ModuleBase {
  columns: Object = {};
  list: any[] = [];

  public getBackgroundColorFromInstance(instance: object) {
    return instance["section_color"]["color"];
  }

  public mounted() {
    this.loadData();
  }

  @Watch("instance")
  public onInstanceChange() {
    this.loadData();
  }

  public async loadData() {
    if (!this.instance) return;
    const rows = JSON.parse(JSON.stringify(this.instance["rows"]));
    let p: Promise<any>[] = [];
    rows.forEach((row) => {
      row.cols.forEach((col) => {
        const isApiCallNeeded = this.checkIfApiCallNeeded(col);
        if (isApiCallNeeded) p.push(this.loadValuesFromService(col));
      });
    });
    try {
      await Promise.all(p);
    } catch (error) {
      this.$store.ui.error((error as any).toString());
    }

    this.columns = this.buildColumns(rows[0]);
    this.list = this.buildList(Object.keys(this.columns), rows.slice(1));
  }

  buildColumns(row: RowData) {
    if (!row) return {};
    let temp: any = {};
    row.cols.forEach((col) => {
      console.log("cellData: ", this.getCellData(col));
      temp[uuidv4()] = { name: this.getCellData(col), isHTML: true };
    });
    console.log("columns: ", temp);
    return temp;
  }

  buildList(columnKeys: string[], rows: RowData[]) {
    if (rows.length < 1) return [];
    console.log("list: ", rows);
    const formattedRows = rows.map((row) => {
      let formattedRow = {};
      columnKeys.forEach((key, index) => {
        formattedRow[key] = this.getCellData(row.cols[index]);
      });
      return formattedRow;
    });
    console.log("formattedRows: ", formattedRows);
    return formattedRows;
  }

  async loadValuesFromService(col: ColData) {
    if (!col.value || typeof col.value === "string") return;
    const id = col.value.filter!.FILTER!;
    let result = await Api.kpiService.getFilterData(parseInt(id));
    col.value = result.count.toString();
    return;
  }

  checkIfApiCallNeeded({ value }: ColData) {
    if (!value || typeof value === "string") return false;
    if (!value.service || !value.service!.startsWith("Common/")) return false;
    if (!value.filter || !value.filter.FILTER) return false;
    return true;
  }

  private getCellData(col: ColData) {
    let colText = col.text;

    if (colText !== "") return this.richTextWrapper(colText, "primary");

    if (col.value !== "") return col.value;

    if (
      col.image !== "" &&
      this.getTranslatedImage(col.image, this.lang, "full") !== null
    )
      return (
        '<img alt="" src="' +
        this.getTranslatedImage(col.image, this.lang, "full") +
        '" />'
      );

    return " ";
  }

  get colSize() {
    return parseInt(this.instance["column_size"]);
  }

  get position() {
    return "justify-content-" + this.instance["position"];
  }

  private richTextWrapper(content, theme) {
    return (
      '<div class="' +
      APP_PREFIX +
      "-rich-text " +
      APP_PREFIX +
      "-rich-text--" +
      theme +
      '">' +
      content +
      "</div>"
    );
  }
}
